import React, { useContext, useRef, useState } from "react";
import { Billing } from "./Billing";
import { Profile } from "./Profile";
import styles from "./styles/MyAccount.module.css";
import { Subscription } from "./Subscription";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { MobPopUp } from "./MobPupUp";
import { UserData } from "../../../Context/DataContext";
import { resetIndex } from "../../../Utils/onboardingButtons";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import ReferralContent from "./referralContent";
import PartnerPortalContent from "./PartnerPortalContent";
import InfluencerPortalContent from "./influencerPortalContent";
import ActivateYourAccount from "./activateAccount";
import { ReactComponent as OkSvg } from "./styles/img/ok.svg";
import { Popover } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import PendingModal from "./pendingModal";
import dayjs from "dayjs";
import PartnerWelcomePopup from "../Dashboard/partnerWelcomePopup";
import useWindowDimensions from "../../Footer/footer";

function MyAccount() {
  const devEnv =
    window?.location?.host.includes("localhost") ||
    window?.location?.host.includes("127.0.0") ||
    window?.location?.host.includes("preprod");
  const userData = UserData();

  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.MyAccount
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [pendingModal, setPendingModal] = useState(false);
  const onCancelPendingModal = () => {
    setPendingModal(false);
  };
  const [openMenu, setOpenMenu] = useState(1);
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.MyAccount);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [openValidateAccountPopup, setOpenValidateAccountPopup] =
    useState(false);
  const onOkValidateAccount = () => {
    setOpenValidateAccountPopup(false);
  };
  const onCancelValidateAccount = () => {
    setOpenValidateAccountPopup(false);
  };
  const [location, setLocation] = useState(useLocation());
  useEffect(() => {
    dayjs(userData.userValidationData.expiration_date).format("YYYY-MM-DD");

    if (location?.state?.recovery_key) {
      setMenu(<Profile scrollToRecovery={location?.state?.recovery_key} />);
    }
    if (location?.state?.updatePayment) {
      setMenu(<Subscription scrolltoPayment={true} />);
    }
    if (location?.state?.subscriptionRenewal) {
      setMenu(<Subscription subscriptionRenewal={true} />);
    }
    setLocation();
  }, []);
  const [navSelection, setNavSelection] = useState(userData.MyAccount);
  const mobileRef = useRef(null);
  const [mobile, setMobile] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (popoverRef.current && openMenu) {
        const rect = popoverRef.current.getBoundingClientRect();

        const isOutOfView =
          rect.top + 200 < 0 || rect.bottom > window.innerHeight;

        if (isOutOfView) {
          setOpenMenu(openMenu + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openMenu]);
  function getNavStyles(value) {
    return value === userData.MyAccount
      ? styles.navElementSelected
      : styles.navElement;
  }

  const [menu, setMenu] = useState(null);
  useEffect(() => {
    switch (userData.MyAccount) {
      case 1:
        setMenu(<Profile scrollToRecovery={location?.state?.recovery_key} />);
        break;
      case 2:
        setMenu(<Billing />);
        break;
      case 3:
        setMenu(
          <Subscription
            scrolltoPayment={location?.state?.updatePayment}
            subscriptionRenewal={location?.state?.subscriptionRenewal}
          />
        );
        break;
      case 4:
        setMenu(<ReferralContent />);
        break;
      case 5:
        setMenu(<PartnerPortalContent />);
        break;
      case 6:
        setMenu(
          <InfluencerPortalContent
            partner_title={dublicatedcontent?.dublicatedText105}
          />
        );
        break;
      default:
        break;
    }
  }, [userData.MyAccount]);
  useEffect(() => {
    userData.updateProducts();
  }, []);
  const getOnboard = (userData) => {
    navigate("/user/dashboard", { replace: true });
    resetIndex();
    setTimeout(() => {
      userData.setCustomerUser({
        ...userData.CustomerUser,
        first_login: true,
      });
    }, 500);
  };
  const activeStatus = UserData()?.userValidationData?.status;
  useEffect(() => {
    if (!userData.MyAccount && userData.CustomerUser.user_type === "Customer")
      userData.setMyAccount(4);
    else if (
      !userData.MyAccount &&
      userData.userValidationData.type === "partner" &&
      activeStatus === "active"
    ) {
      userData.setMyAccount(5);
    } else if (
      !userData.MyAccount &&
      userData.userValidationData.type === "other" &&
      activeStatus === "active"
    ) {
      userData.setMyAccount(5);
    } else if (
      ((!userData.MyAccount && userData.userValidationData.type === "agency") ||
        (!userData.MyAccount &&
          userData.userValidationData.type === "legal advisor")) &&
      activeStatus === "active"
    ) {
      userData.setMyAccount(5);
    } else if (
      !userData.MyAccount &&
      userData.userValidationData.type === "influencer"
    ) {
      userData.setMyAccount(6);
    } else if (userData.MyAccount) userData.setMyAccount(userData.MyAccount);
    else userData.setMyAccount(1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(()=>{

  //     if (!userData.MyAccount) userData.setMyAccount(1)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  const isFirstLogin = userData.CustomerUser?.first_login;
  return (
    <div className={styles.main}>
      {isFirstLogin &&
        userData.CustomerUser.show_welcome_popup === true &&
        (!userData.CustomerUser.register_code ||
          userData.CustomerUser.register_code === "undefined") &&
        userData.CustomerUser.user_type.toLowerCase() === "partner" && (
          <PartnerWelcomePopup
            date={dayjs(userData?.userValidationData?.expiration_date).format(
              "YYYY-MM-DD"
            )}
            onClose={() => {
              userData.setCustomerUser({
                ...userData.CustomerUser,
                show_welcome_popup: false,
                first_login: false,
              });
            }}
          ></PartnerWelcomePopup>
        )}

      {width > (localStorage.getItem("language") === "fr" ? 1024 : 835) && (
        <div style={{ marginBottom: "30px" }}>
          <div className={styles.title}>{content.myAccountTitle1}</div>
          <div
            className={styles.user_id_text}
          >{`${dublicatedcontent.dublicatedText97}: ${userData.UserData.user_id}`}</div>
        </div>
      )}
      <div className={styles.content}>
        {/* {width < (localStorage.getItem("language") === "fr" ? 1300 : 835) && (
          <>
            {" "}
            {userData.userValidationData.validated === "false" &&
              (userData.MyAccount === 4 ||
                userData.MyAccount === 5 ||
                userData.MyAccount === 6) && (
                <p
                  style={{
                    color: "#0091EA",
                    fontWeight: 400,
                    fontSize: "12px",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    setOpenValidateAccountPopup(true);
                  }}
                >
                  Please Validate Your Account
                </p>
              )}
            {userData.userValidationData.validated === "pending" &&
              (userData.MyAccount === 4 ||
                userData.MyAccount === 5 ||
                userData.MyAccount === 6) && (
                <p
                  style={{
                    color: "#0091EA",
                    fontWeight: 400,
                    fontSize: "12px",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    setPendingModal(true);
                  }}
                >
                  Your validation request is currently being processed
                </p>
              )}
            {userData.userValidationData.validated === "true" &&
              (userData.MyAccount === 4 ||
                userData.MyAccount === 5 ||
                userData.MyAccount === 6) && (
                <div>
                  <OkSvg />
                  <p
                    style={{
                      color: "#419F23",
                      fontWeight: 400,
                      fontSize: "12px",
                    }}
                  >
                    Validated
                  </p>
                </div>
              )}
          </>
        )} */}
        <div>
          <PendingModal open={pendingModal} onCancel={onCancelPendingModal} />

          <ActivateYourAccount
            open={openValidateAccountPopup}
            onOk={onOkValidateAccount}
            onCancel={onCancelValidateAccount}
          />
          {width > (localStorage.getItem("language") === "fr" ? 1024 : 835) && (
            <div className={styles.navBar}>
              <div
                onClick={() => userData.setMyAccount(1)}
                className={getNavStyles(1)}
              >
                {dublicatedcontent.dublicatedText77}
              </div>
              <div
                onClick={() => userData.setMyAccount(2)}
                className={getNavStyles(2)}
              >
                {content.myAccountText2}
              </div>
              <div
                onClick={() => userData.setMyAccount(3)}
                className={getNavStyles(3)}
              >
                {content.myAccountText3}
              </div>

              {userData.CustomerUser.user_type === "Customer" && (
                <div
                  onClick={() => userData.setMyAccount(4)}
                  className={getNavStyles(4)}
                >
                  {dublicatedcontent.dublicatedText103}
                </div>
              )}
              {userData?.userValidationData?.status?.toLowerCase() ==
                "active" &&
                userData.CustomerUser.user_type?.toLowerCase() ===
                  "partner" && (
                  <div
                    onClick={() =>
                      userData?.userValidationData?.type?.toLowerCase() ===
                      "influencer"
                        ? userData.setMyAccount(6)
                        : userData.setMyAccount(5)
                    }
                    className={
                      userData?.userValidationData?.type?.toLowerCase() ===
                      "influencer"
                        ? getNavStyles(6)
                        : getNavStyles(5)
                    }
                  >
                    {/* {userData?.userValidationData?.type?.toLowerCase() ===
                    "influencer"
                      ? dublicatedcontent?.dublicatedText105
                      : dublicatedcontent?.dublicatedText104} */}
                    {dublicatedcontent?.dublicatedText104}
                  </div>
                )}
              {/* {(userData.userValidationData.type === "partner"||userData.userValidationData.type === "agency"||userData.userValidationData.type === "other") && (
                  <div
                    onClick={() => userData.setMyAccount(5)}
                    className={getNavStyles(5)}
                  >
                    {dublicatedcontent.dublicatedText104}
                  </div>
              )} */}
              {/* {userData.userValidationData.type === "other" &&
                UserData()?.userValidationData?.status === "active" && (
                  <div
                    onClick={() => userData.setMyAccount(5)}
                    className={getNavStyles(5)}
                  >
                    {dublicatedcontent.dublicatedText104}
                  </div>
                )}
              {userData.userValidationData.type === "influencer" &&
                UserData()?.userValidationData?.status === "active" && (
                  <div
                    onClick={() => userData.setMyAccount(6)}
                    className={getNavStyles(6)}
                  >
                    {dublicatedcontent.dublicatedText105}
                  </div>
                )} */}
              <div
                onClick={() => getOnboard(userData)}
                className={getNavStyles(7)}
              >
                {content.myAccountText5}
              </div>
              <div
                onClick={() => navigate("/logout", { replace: true })}
                className={`${getNavStyles(8)} ${styles.logout}`}
              >
                {dublicatedcontent.dublicatedText70}
              </div>
            </div>
          )}
        </div>

        {width < (localStorage.getItem("language") === "fr" ? 1024 : 835) && (
          <div>
            <PendingModal open={pendingModal} onCancel={onCancelPendingModal} />

            <ActivateYourAccount
              open={openValidateAccountPopup}
              onOk={onOkValidateAccount}
              onCancel={onCancelValidateAccount}
            />

            <div
              className={styles.navBar}
              style={
                localStorage.getItem("language") === "fr" &&
                width < 1024 &&
                width > 835
                  ? {
                      marginBottom: "20px",
                    }
                  : {}
              }
            >
              <div className={styles.mobileTitleContainer}>
                <div className={styles.mobileTitle}>
                  {userData.MyAccount === 1 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {dublicatedcontent.dublicatedText77}
                    </h3>
                  )}
                  {userData.MyAccount === 2 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {content.myAccountText2}
                    </h3>
                  )}
                  {userData.MyAccount === 3 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {content.myAccountText3}
                    </h3>
                  )}
                  {userData.MyAccount === 4 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {dublicatedcontent.dublicatedText103}
                    </h3>
                  )}
                  {userData.MyAccount === 5 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {dublicatedcontent.dublicatedText104}
                    </h3>
                  )}
                  {userData.MyAccount === 6 && (
                    <h3 className={styles.mobileTitleTitle}>
                      {dublicatedcontent.dublicatedText104}
                    </h3>
                  )}

                  <Popover
                    key={openMenu}
                    style={{
                      width: "100%",
                    }}
                    placement="bottom"
                    content={
                      <div
                        ref={popoverRef}
                        className={styles.popover}
                        onClick={() => {
                          setOpenMenu(openMenu + 1);
                        }}
                      >
                        <p
                          onClick={() => userData.setMyAccount(1)}
                          className={getNavStyles(1)}
                        >
                          {dublicatedcontent.dublicatedText77}
                        </p>
                        <p
                          onClick={() => userData.setMyAccount(2)}
                          className={getNavStyles(2)}
                        >
                          {content.myAccountText2}
                        </p>
                        <p
                          onClick={() => userData.setMyAccount(3)}
                          className={getNavStyles(3)}
                        >
                          {content.myAccountText3}
                        </p>
                        {userData.CustomerUser.user_type === "Customer" && (
                          <p
                            onClick={() => userData.setMyAccount(4)}
                            className={getNavStyles(4)}
                          >
                            {dublicatedcontent.dublicatedText103}
                          </p>
                        )}
                        {userData?.userValidationData?.status?.toLowerCase() ==
                          "active" &&
                          userData.CustomerUser.user_type?.toLowerCase() ===
                            "partner" && (
                            <p
                              onClick={() =>
                                userData?.userValidationData?.type?.toLowerCase() ===
                                "influencer"
                                  ? userData.setMyAccount(6)
                                  : userData.setMyAccount(5)
                              }
                              className={
                                userData?.userValidationData?.type?.toLowerCase() ===
                                "influencer"
                                  ? getNavStyles(6)
                                  : getNavStyles(5)
                              }
                            >
                              {/* {userData?.userValidationData?.type?.toLowerCase() ===
                              "influencer"
                                ? dublicatedcontent?.dublicatedText105
                                : dublicatedcontent?.dublicatedText104} */}
                              {dublicatedcontent?.dublicatedText104}
                            </p>
                          )}
                        {/* <div>
                          {userData.userValidationData.type === "partner" && (
                            <p
                              onClick={() => userData.setMyAccount(5)}
                              className={getNavStyles(5)}
                            >
                              {dublicatedcontent.dublicatedText104}
                            </p>
                          )}
                          {userData.userValidationData.type === "other" && (
                            <p
                              onClick={() => userData.setMyAccount(5)}
                              className={getNavStyles(5)}
                            >
                              {dublicatedcontent.dublicatedText104}
                            </p>
                          )}
                          {userData.userValidationData.type ===
                            "influencer" && (
                            <p
                              onClick={() => userData.setMyAccount(6)}
                              className={getNavStyles(6)}
                            >
                              {dublicatedcontent.dublicatedText105}
                            </p>
                          )}
                        </div> */}
                        <p
                          style={{
                            color: "rgba(189, 0, 0, 1)",
                          }}
                          className={getNavStyles(7)}
                          onClick={() => navigate("/logout", { replace: true })}
                        >
                          {dublicatedcontent.dublicatedText70}
                        </p>
                      </div>
                    }
                  >
                    <div className={styles.navMenuIcon}>
                      <MenuOutlined
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </Popover>
                </div>
                {userData.userValidationData.validated === "false" &&
                  (userData.MyAccount === 4 ||
                    userData.MyAccount === 5 ||
                    userData.MyAccount === 6) && (
                    <p
                      style={{
                        color: "#0091EA",
                        fontWeight: 400,
                        fontSize: "14px",
                        textDecoration: "underline",
                        cursor: "pointer",
                        margin: "0",
                      }}
                      onClick={(e) => {
                        setOpenValidateAccountPopup(true);
                      }}
                    >
                      {dublicatedcontent.dublicatedText106}
                    </p>
                  )}
                {userData.userValidationData.validated === "pending" &&
                  (userData.MyAccount === 4 ||
                    userData.MyAccount === 5 ||
                    userData.MyAccount === 6) && (
                    <p
                      style={{
                        color: "#0091EA",
                        fontWeight: 400,
                        fontSize: "14px",
                        textDecoration: "underline",
                        cursor: "pointer",
                        margin: "0",
                        textAlign: "center",
                      }}
                      onClick={(e) => {
                        setPendingModal(true);
                      }}
                    >
                      {dublicatedcontent.dublicatedText107}
                    </p>
                  )}
                {userData.userValidationData.validated === "true" &&
                  (userData.MyAccount === 4 ||
                    userData.MyAccount === 5 ||
                    userData.MyAccount === 6) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <OkSvg />
                      <p
                        style={{
                          color: "#419F23",
                          fontWeight: 400,
                          fontSize: "14px",
                          margin: "0",
                        }}
                      >
                        {dublicatedcontent.dublicatedText108}
                      </p>
                    </div>
                  )}
                {/* {userData.userValidationData.validated === "false" ? (
                  <p
                    style={{
                      color: "#0091EA",
                      fontWeight: 400,
                      fontSize: "12px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      // setOpenValidateAccountPopup(true);
                    }}
                  >
                    Please Validate Your Account
                  </p>
                ) : userData.userValidationData.validated === "pending" ? (
                  <p
                    style={{
                      color: "#0091EA",
                      fontWeight: 400,
                      fontSize: "12px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      // setPendingModal(true);
                    }}
                  >
                    Your validation request is currently being processed
                  </p>
                ) : (
                  <div>
                    <OkSvg />
                    <p
                      style={{
                        color: "#419F23",
                        fontWeight: 400,
                        fontSize: "12px",
                      }}
                    >
                      Validated
                    </p>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        )}
        <div
          className={styles.main_div}
          style={
            userData.MyAccount === 4
              ? { padding: "44px 60px" }
              : userData.MyAccount === 5 || userData.MyAccount === 6
              ? { padding: "44px 60px", backgroundColor: "white" }
              : {}
          }
        >
          {menu}
        </div>
      </div>
      <div ref={mobileRef} className={styles.mobile}>
        {menu && mobile && (
          <MobPopUp
            OnBack={() => {
              setNavSelection(5);
            }}
            children={menu}
          />
        )}
      </div>
    </div>
  );
}
export { MyAccount };
